import UserDashboardPage from './UserDashboardPage'
import { userDashboardMenu } from './sideBarOption'

export { userDashboardMenu }
export default UserDashboardPage
